export default __webpack_public_path__ + "70ca420b8e34c4518008ed50c688d6af.png";